import { PAYMENT_METHODS, type PaymentMethod } from '@gl/shared';

/**
 * Paleta categórica validada (orden fijo, nunca ciclado) con su versión para modo oscuro.
 * Los colores siguen a la entidad: Ventas, Gastos e Ingresos siempre usan el mismo slot.
 */
const CSS = `
.gl-viz {
  --viz-1: #2a78d6; --viz-2: #eb6834; --viz-3: #1baf7a; --viz-4: #eda100;
  --viz-5: #e87ba4; --viz-6: #008300;
  --viz-grid: oklch(0.91 0.008 350); --viz-axis: oklch(0.5 0.015 350); --viz-surface: oklch(1 0 0);
}
.dark .gl-viz {
  --viz-1: #3987e5; --viz-2: #d95926; --viz-3: #199e70; --viz-4: #c98500;
  --viz-5: #d55181; --viz-6: #008300;
  --viz-grid: oklch(1 0 0 / 10%); --viz-axis: oklch(0.7 0.015 350); --viz-surface: oklch(0.2 0.01 350);
}
`;

export function ChartStyles() {
  return <style>{CSS}</style>;
}

export const SERIES = {
  sales: 'var(--viz-1)',
  expenses: 'var(--viz-2)',
  incomes: 'var(--viz-3)',
} as const;

export const GRID = 'var(--viz-grid)';
export const AXIS = 'var(--viz-axis)';
export const SURFACE = 'var(--viz-surface)';

/** Cada método de pago tiene su slot fijo (sigue a la entidad, no al ranking). */
export const PAYMENT_COLORS: Record<PaymentMethod, string> = Object.fromEntries(
  PAYMENT_METHODS.map((m, i) => [m, `var(--viz-${i + 1})`]),
) as Record<PaymentMethod, string>;

const compact = new Intl.NumberFormat('es-AR', { notation: 'compact', maximumFractionDigits: 1 });

/** Ticks del eje Y en pesos: "$ 0", "$ 1,5 mil", "$ 2 M". */
export function axisARS(cents: number): string {
  return `$ ${compact.format(cents / 100)}`;
}
